export const toQueryString = (
  params: Record<string, string | string[]>,
): string => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    const values = Array.isArray(value) ? value : [value];
    values.forEach((entry) => searchParams.append(key, entry));
  });
  return searchParams.toString();
};
